// eve-last-image-store — merkt sich pro Page das ZULETZT hochgeladene Bild
// (Chart), damit Folgefragen OHNE erneuten Upload EVE denselben Chart mitgeben.
//
// Bewusst NICHT persistiert (nur im Speicher der laufenden Session): Base64-
// Charts im localStorage würden das Quota schnell sprengen. Nach einem harten
// Reload muss der User das Bild erneut hochladen — innerhalb einer Session
// funktionieren Folgefragen aber nahtlos.
//
// Staleness-Grenze: das gemerkte Bild wird nur für die nächsten REUSE_WINDOW
// Nachrichten auf derselben Page wiederverwendet. Danach gilt es als „nicht
// mehr das aktuelle Thema" und wird nicht mehr angehängt.

export interface StoredImage {
  imageData: string;
  imageMime: string;
}

interface StoredEntry extends StoredImage {
  /** Nachrichten-Anzahl der Page zum Zeitpunkt des Uploads. */
  atCount: number;
}

/** Wieviele Folge-Nachrichten lang ein Bild ohne neuen Upload wiederverwendet wird. */
export const REUSE_WINDOW = 12;

const byPage = new Map<string, StoredEntry>();

/** Merkt ein frisch hochgeladenes Bild für die Page. */
export function rememberImage(
  pageKey: string,
  imageData: string,
  imageMime: string,
  atCount: number,
): void {
  byPage.set(pageKey, { imageData, imageMime, atCount });
}

/**
 * Liefert das gemerkte Bild der Page zurück — aber nur, wenn es innerhalb des
 * REUSE_WINDOW liegt (sonst `null`). `currentCount` ist die aktuelle Nachrichten-
 * Anzahl der Page.
 */
export function recallImage(pageKey: string, currentCount: number): StoredImage | null {
  const entry = byPage.get(pageKey);
  if (!entry) return null;
  if (currentCount - entry.atCount > REUSE_WINDOW) {
    byPage.delete(pageKey);
    return null;
  }
  return { imageData: entry.imageData, imageMime: entry.imageMime };
}

/** Vergisst das gemerkte Bild der Page (z.B. wenn der Verlauf gelöscht wird). */
export function clearImage(pageKey: string): void {
  byPage.delete(pageKey);
}

/** Nur für Tests: kompletter Reset. */
export function __resetLastImages(): void {
  byPage.clear();
}
